"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("./_user-profile.scss");

function UserProfile(_ref) {
  var imageUrl = _ref.imageUrl,
      color = _ref.color,
      name = _ref.name,
      isUser = _ref.isUser;
  return _react["default"].createElement("div", {
    className: "comment-user-profile"
  }, isUser ? null : _react["default"].createElement(_uiKit.Image, {
    height: "20px",
    width: "20px",
    circular: !0,
    imageUrl: imageUrl,
    placeholderText: name,
    placeholderTextSize: 9,
    backgroundSize: "cover"
  }), _react["default"].createElement("span", {
    style: {
      color: color
    }
  }, isUser ? "YOU" : name));
}

var _default = (0, _react.memo)(UserProfile);

exports["default"] = _default;